export default __webpack_public_path__ + "static/media/icn-arrow-down-copy-2.67f7f4de.svg";